import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
	withMobileDialog,
	Dialog,
	withStyles,
	DialogActions,
	Button,
} from '@material-ui/core'
import { toggleTaskModal } from 'actions/campaign/addOrEdit'
import AddOrEditTaskPage from 'components/AddOrEditTaskPage'

export default withRouter(
	connect(
		(state) => ({
			taskModalOpen: state.campaign.addOrEdit.taskModalOpen,
			splitFormDisplayed: state.tasks.addOrEdit.splitFormDisplayed,
		}),
		(dispatch) => bindActionCreators({ toggleTaskModal }, dispatch),
	)(
		withStyles((theme) => ({
			rounded: {
				borderRadius: 28,
				overflowY: 'hidden',
				height: '100%',
				[theme.breakpoints.down('sm')]: {
					borderRadius: 0,
					overflowY: 'auto',
					overflowX: 'hidden',
				},
			},
			dialogActionsRoot: {
				[theme.breakpoints.down('sm')]: {
					margin: '-50px 25px 0',
				},
			},
		}))(
			withMobileDialog()(
				({
					history,
					match,
					fullScreen,
					toggleTaskModal,
					taskModalOpen,
					classes,
					splitFormDisplayed,
				}) => (
					<Dialog
						fullWidth
						maxWidth="xl"
						fullScreen={fullScreen}
						open={Boolean(taskModalOpen)}
						onClose={() => toggleTaskModal()}
						aria-labelledby="responsive-dialog-title"
						disableBackdropClick
						disableEscapeKeyDown
						PaperProps={{ classes: { rounded: classes.rounded } }}
					>
						<AddOrEditTaskPage
							modal={taskModalOpen}
							taskID={taskModalOpen.taskID || 'new'}
							match={match}
							style={splitFormDisplayed ? null : { overflowY: 'auto' }}
						/>
						<DialogActions classes={{ root: classes.dialogActionsRoot }}>
							<Button color="secondary" onClick={() => toggleTaskModal()}>
								Close
							</Button>
						</DialogActions>
					</Dialog>
				),
			),
		),
	),
)
